module.exports = __webpack_public_path__ + "static/media/frame_55.66d313ad.jpg";